// extracted by mini-css-extract-plugin
export default {"requiredIcon":"PunchupCustomQuestionTile_requiredIcon__u0WyK"};